export const TPR_RUN_CHECKS_SINGLE_MESSAGE = 'Test this procedure'
export const TPR_RUN_CHECKS_MULTI_MESSAGE = 'Test these procedures'
export const TPR_RUN_CHECKS_MESSAGES = new Set([
  TPR_RUN_CHECKS_SINGLE_MESSAGE,
  TPR_RUN_CHECKS_MULTI_MESSAGE,
])
